module.exports = __webpack_public_path__ + "static/media/coming-soon-icon.a9e5b8bd.svg";